import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mileage"
const MileageIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8.852c0 2.37-3.111 6.815-4 6.815-.889 0-4-4.445-4-6.815C2 6.725 3.79 5 6 5s4 1.725 4 3.852ZM7.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM18 15.667c.889 0 4-4.445 4-6.815C22 6.725 20.21 5 18 5s-4 1.725-4 3.852c0 2.37 3.111 6.815 4 6.815ZM19.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM6 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
          />
        </svg>
      }
    </span>
  )
}
export default MileageIcon
